import { CardBody, Button } from "@nextui-org/react";
import useAudioPlayer from "../hooks/useAudioPlayer";
import { Play, Pause, Loading } from "../media/icons";

export default function PlayButton() {
    const { isPlaying, isLoading, toggle } = useAudioPlayer();
    const visibilityClass = isPlaying ? "opacity-0 hover:transition-opacity hover:opacity-100 hover:ease-in duration-300 hover:duration-300" : "";

    const icon = (() => {
        if (isLoading) return <Loading />;
        if (isPlaying) return <Pause />;
        return <Play />;
    })();

    return (
        <CardBody className={`flex w-full h-full bg-black/30 justify-center items-center ${visibilityClass} absolute z-10`}>
            <Button isIconOnly disableRipple isDisabled={isLoading} onPress={toggle} className="bg-transparent w-3/5 h-3/5">
                <div className="flex relative hover:visible inline-flex flex-col w-3/5 h-3/5 gap-2 items-center justify-center">
                    {icon}
                </div>
            </Button>
        </CardBody>
    );
}
